import React from 'react';
import { WarningLoader, ThumbLoader, PercentageLoader } from '@next-common/shared-svg';
import { isCurrentRankBetterThanNextRank, isCurrentRankTwoOrThreeRanksAboveNextRank, capitalizeRankInString, } from './clubRankingHelper';
import { rankStatus } from './ClubRanking.model';
const HubPageHelper = (status) => {
    switch (status) {
        case rankStatus.REGULAR:
            return ({
                hubBgColor: '#FF6161',
                hubAmountColor: '#FF6161',
                hoverColor: '#FFEFEF',
                btnColor: 'regular',
            });
        case rankStatus.SILVER:
            return ({
                hubBgColor: '#9C9C9C',
                hubAmountColor: '#000',
                hoverColor: '#F5F5F5',
                btnColor: 'black',
            });
        case rankStatus.GOLD:
            return ({
                hubBgColor: '#FFC026',
                hubAmountColor: '#DB8600',
                hoverColor: '#FFF9E9',
                btnColor: 'gold-dark',
            });
        case rankStatus.PLATINUM:
            return ({
                hubBgColor: '#4DC4FF',
                hubAmountColor: '#0085C7',
                hoverColor: '#EDF9FF',
                btnColor: 'platinum',
            });
        default:
            return ({
                hubBgColor: '#FF6161',
                hubAmountColor: '#FF6161',
                hoverColor: '#FFEFEF',
                btnColor: 'regular',
            });
            ;
    }
};
const iconManager = (rank, nextRank, rankProgression) => {
    const helper = HubPageHelper(rank);
    const formatedRankProgression = new Intl.NumberFormat().format(rankProgression);
    const formatedRank = capitalizeRankInString(rank);
    const formatedNextRank = capitalizeRankInString(nextRank);
    if (isCurrentRankBetterThanNextRank(formatedRank, formatedNextRank)
        || isCurrentRankTwoOrThreeRanksAboveNextRank(formatedRank, formatedNextRank)) {
        return React.createElement(WarningLoader, { percentage: rankProgression, fill: helper.hubAmountColor });
    }
    if (rankProgression === 100) {
        return React.createElement(ThumbLoader, { percentage: rankProgression, fill: helper.hubAmountColor });
    }
    return React.createElement(PercentageLoader, { percentage: rankProgression, formattedPercentage: formatedRankProgression, fill: helper.hubAmountColor });
};
export { HubPageHelper, iconManager };
